<template>
    <v-card outlined class="bMolecule white--text">
        <div class="bMolecule darken-1 pa-4">
            <div class="subtitle-1 font-weight-medium">
                <span>Your 5 attributes which defines you</span>
            </div>
        </div>

        <v-card-text class="pa-6" v-if="loaded">
            <v-card class="transparent mx-auto white--text" flat width="220">
                <div class="d-flex align-center" v-for="(item, index) in model" :key="item.id">
                    <div class="title mr-2">{{index+1}}.</div>
                    <div class="title font-weight-regular">{{item}}</div>
                </div>
            </v-card>
            
            <v-divider class="mt-6"></v-divider>

            <div class="mt-6 text-center">
                <v-btn outlined class="white--text mr-2" @click="$emit('edit')">Edit attributes</v-btn>
                <v-btn class="white bMolecule--text text--darken-1" @click="$emit('continue')">
                    Continue
                    <v-icon small right color="bMolecule">fa-angle-right</v-icon>
                </v-btn>
            </div>

        </v-card-text>
    </v-card>
</template>

<script>
import Helpers from '@/services/helpers'

export default {
    data: () => ({
        loaded: false,
        model: [],
    }),
    props: ['attributes'],
    mounted() {
        this.init();
    },
    methods: {
        init() {
            let tempo = JSON.parse(JSON.stringify(this.attributes));
            for (let i in tempo) {
                this.model.push(tempo[i]);
            }
            this.loaded = true;
        }
    }
}
</script>

<style scoped>
    a {
        color: white !important;
    }
</style>
